// extracted by mini-css-extract-plugin
export default {"container":"oSc5Urn"};